{
  "metadata": {
    "id": "kanagawa-dark",
    "name": "Kanagawa",
    "description": "Портировано из темы «Kanagawa» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "kanagawa.json",
      "project": "rebelot",
      "url": "https://github.com/rebelot/kanagawa.nvim",
      "upstreamFile": "packages/ui/src/theme/themes/kanagawa.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.4,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.453,
      "paletteMaxS": 0.535,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.3,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.5,
      "syntaxVsTextMinDeltaE": 24.7,
      "chartsMinDeltaE": 23.0,
      "textSeparationDeltaE": 21.8,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "type",
          "b": "operator",
          "deltaE": 13.1
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#7E9CD8",
      "hover": "#8da8dd",
      "active": "#98b0e0",
      "foreground": "#000000",
      "muted": "#7e9cd880",
      "emphasis": "#7E9CD8"
    },
    "surface": {
      "background": "#1F1F28",
      "foreground": "#DCD7BA",
      "muted": "#313137",
      "mutedForeground": "#a4a49d",
      "elevated": "#3a3a3e",
      "elevatedForeground": "#DCD7BA",
      "raised": "#545352",
      "raisedForeground": "#DCD7BA",
      "overlay": "#1f1f28cc",
      "subtle": "#292830"
    },
    "interactive": {
      "border": "#565555",
      "borderHover": "#545351",
      "borderFocus": "#7E9CD8",
      "selection": "#dcd7ba29",
      "selectionForeground": "#DCD7BA",
      "focus": "#7e9cd859",
      "focusRing": "#7e9cd861",
      "cursor": "#dcd7ba",
      "hover": "#dcd7ba1c",
      "active": "#dcd7ba29"
    },
    "status": {
      "error": "#ed5252",
      "errorForeground": "#000000",
      "errorBackground": "#ed525224",
      "errorBorder": "#ed525273",
      "warning": "#D7A657",
      "warningForeground": "#000000",
      "warningBackground": "#d7a65724",
      "warningBorder": "#d7a65773",
      "success": "#98BB6C",
      "successForeground": "#000000",
      "successBackground": "#98bb6c24",
      "successBorder": "#98bb6c73",
      "info": "#76946A",
      "infoForeground": "#000000",
      "infoBackground": "#76946a24",
      "infoBorder": "#76946a73"
    },
    "pr": {
      "open": "#98BB6C",
      "draft": "#b0afa9",
      "blocked": "#D7A657",
      "merged": "#D27E99",
      "closed": "#ed5252"
    },
    "syntax": {
      "base": {
        "background": "#424245",
        "foreground": "#DCD7BA",
        "comment": "#c8c7c3",
        "keyword": "#b9a6d9",
        "string": "#98BB6C",
        "number": "#D7A657",
        "function": "#9fb496",
        "variable": "#DCD7BA",
        "type": "#cfa4b1",
        "operator": "#dd9cb1"
      },
      "tokens": {
        "commentDoc": "#c8c7c3",
        "stringEscape": "#dd9cb1",
        "keywordImport": "#b9a6d9",
        "storageModifier": "#b9a6d9",
        "functionCall": "#9fb496",
        "method": "#9fb496",
        "variableProperty": "#9fb496",
        "variableOther": "#DCD7BA",
        "variableGlobal": "#D7A657",
        "variableLocal": "#dd9cb1",
        "parameter": "#DCD7BA",
        "constant": "#D7A657",
        "class": "#cfa4b1",
        "className": "#cfa4b1",
        "interface": "#cfa4b1",
        "struct": "#cfa4b1",
        "enum": "#cfa4b1",
        "typeParameter": "#cfa4b1",
        "namespace": "#cfa4b1",
        "module": "#b9a6d9",
        "tag": "#b9a6d9",
        "jsxTag": "#b9a6d9",
        "tagAttribute": "#9fb496",
        "tagAttributeValue": "#98BB6C",
        "boolean": "#D7A657",
        "decorator": "#b9a6d9",
        "label": "#9fb496",
        "regexp": "#98BB6C"
      }
    },
    "charts": {
      "series": [
        "#7E9CD8",
        "#76946A",
        "#98BB6C",
        "#D7A657",
        "#ed5252"
      ]
    },
    "chat": {
      "background": "#1F1F28",
      "userMessage": "#DCD7BA",
      "userMessageBackground": "#3a3a3e",
      "assistantMessage": "#DCD7BA",
      "assistantMessageBackground": "#313137",
      "timestamp": "#b0afa9",
      "divider": "#565555",
      "typing": "#b0afa9"
    },
    "loading": {
      "spinner": "#7E9CD8",
      "spinnerTrack": "#313137",
      "skeleton": "#313137",
      "shimmer": "#4b4b4c"
    },
    "tools": {
      "background": "#313137",
      "border": "#565555",
      "headerHover": "#4a494b",
      "icon": "#7E9CD8",
      "title": "#DCD7BA",
      "description": "#b0afa9",
      "edit": {
        "added": "#98BB6C",
        "addedBackground": "#98bb6c24",
        "removed": "#ed5252",
        "removedBackground": "#ed525224",
        "modified": "#76946A",
        "modifiedBackground": "#76946a24",
        "lineNumber": "#b0afa9"
      }
    },
    "markdown": {
      "heading1": "#DCD7BA",
      "heading2": "#DCD7BA",
      "heading3": "#DCD7BA",
      "heading4": "#DCD7BA",
      "link": "#7E9CD8",
      "linkHover": "#8da8dd",
      "inlineCode": "#98BB6C",
      "inlineCodeBackground": "#313137",
      "blockquote": "#b0afa9",
      "blockquoteBorder": "#565555",
      "listMarker": "#7e9cd8bf",
      "bold": "#DCD7BA",
      "italic": "#dcd7bae6",
      "strikethrough": "#b0afa9",
      "hr": "#565555"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c05242",
        "foreground": "#ffffff",
        "contrast": 4.64
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#dab9aa",
        "foreground": "#000000",
        "contrast": 11.5
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#b58b54",
        "foreground": "#000000",
        "contrast": 6.79
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c8c957",
        "foreground": "#000000",
        "contrast": 11.95
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#cde2aa",
        "foreground": "#000000",
        "contrast": 15.05
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#54c650",
        "foreground": "#000000",
        "contrast": 9.57
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#77cd85",
        "foreground": "#000000",
        "contrast": 10.86
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#5bb79e",
        "foreground": "#000000",
        "contrast": 8.71
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#addadc",
        "foreground": "#000000",
        "contrast": 13.84
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#569cb4",
        "foreground": "#000000",
        "contrast": 6.81
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#a3a9db",
        "foreground": "#000000",
        "contrast": 9.26
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3841b9",
        "foreground": "#ffffff",
        "contrast": 8.0
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8a72bf",
        "foreground": "#000000",
        "contrast": 5.24
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#a146be",
        "foreground": "#ffffff",
        "contrast": 5.08
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c04790",
        "foreground": "#ffffff",
        "contrast": 4.62
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#db97b9",
        "foreground": "#000000",
        "contrast": 9.14
      }
    ]
  }
}
